import { Component, Vue } from 'vue-property-decorator'
import {
    getMarketCooperationConsultDataExport,
    getMarketCooperationVisitByMarketCooperationId,
    getMarketCooperationVisitDataExport
} from '@/api/common'
import {menuBtn} from "@/utils/menu_level2_button";
import {formatDate} from "@/utils/timeFilter";
import {UserModule} from "@/store/modules/user";
import {delNullProperty} from "@/utils";


@Component({})
export default class VisitRecord extends Vue {
  tableData = []
  page = 1
  limit = 50
  total = 0
  id = 0
  exportBUttonDisabled = false
  userIdList = []
  visitAt: Date[] | null = null

    get userList() {
        return UserModule.userList
    }

  // created()
  created() {
    const query = this.$route.query
    this.id = Number(query.id)
    this.getData()
    this.$nextTick(() => {
      (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
          const height = res.target;
          const clientHeight = height.clientHeight;
          const scrollTop = height.scrollTop;
          const scrollHeight = height.scrollHeight;
          if (clientHeight + scrollTop >= scrollHeight) {
              if(this.total >= this.tableData.length) {

                  return
              }
              this.page += 2
              this.getData()
          }
      }, true);
  })
  }
  // methods
  async getData() {
      const data: any = await getMarketCooperationVisitByMarketCooperationId(delNullProperty({
          page: this.page,
          limit: this.limit,
          marketCooperationId: this.id,
          userIdList: this.userIdList,
          visitAt: this.changeTime(this.visitAt as Date[]),
      }))
      this.total = data.allNum
      this.tableData = data.marketCooperationVisitList.map((item: any) => ({...item}))
  }

    pageChange(page: number) {
        this.page = page
        this.getData()
    }
// 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    exportExcel() {
        this.exportBUttonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        getMarketCooperationVisitDataExport(delNullProperty(
            {
                marketCooperationId: this.id as number,
                userIdList: this.userIdList,
                visitAt: this.changeTime(this.visitAt as Date[]),
            })).then(() => {
            this.exportBUttonDisabled = false
        }).catch(() => {
            this.exportBUttonDisabled = false
        })
    }

    /*
   按钮权限验证
   */
    handleBtn(id: number) {
        return menuBtn(id)
    }
}
